<template>
    <h3 class="mt-5 mb-5 p-4 text-center">«Дао, которое может быть выражено словами не есть постоянное дао...»</h3>
</template>

<script>
export default {
  name: "CommonPhrase"
};
</script>

<style scoped>
</style>
